import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div>
      <footer>
        <div className="content">
          <div className="top">
            <div className="logo-details">
              <div className="logo_foo">
                <Link to="/">
                  <img src="https://mediadunes.com/footer-logo.png" alt="Mediadunes company logo" />
                </Link>
                <p className='footer-p'>
                  Marasi Drive 51, DAMAC<br />
                  Business Tower 907,<br />
                  Business Bay, Dubai UAE
                </p>
              </div>
            </div>

            <div className="media-icons">
              <a href="https://www.facebook.com/mediadunesofficial" target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a>
              <a href="https://twitter.com/mediadunes" target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a>
              <a href="https://www.instagram.com/mediadunesofficial" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
              <a href="https://www.linkedin.com/company/mediadunes/" target="_blank" rel="noreferrer"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://youtube.com/@mediadunesofficial" target="_blank" rel="noreferrer"><i className="fab fa-youtube"></i></a>
            </div>
          </div>

          <div className="link-boxes">
            <ul className="box">
              <li className="link_name">Company</li>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/price">Price</Link></li>
              <li><Link to="/contactus">Contact Us</Link></li>
              <li><Link to="/blogs">Blogs</Link></li>
            </ul>

            <ul className="box">
              <li className="link_name">Services</li>
              <li><Link to="/Print-Design">Print design</Link></li>
              <li><Link to="/Digital-Design">Digital ad design</Link></li>
              <li><Link to="/logos">Logo design</Link></li>
              <li><Link to="/flyers">Flyer design</Link></li>
            </ul>

            <ul className="box">
              <li className="link_name">Account</li>
              <li><Link to="/uiuxdesign">UI/UX Design</Link></li>
              <li><Link to="/graphic">Graphic Design</Link></li>
              <li><Link to="/Infographic-Design">Infographic Design</Link></li>
              <li><Link to="/Social-Media-Design">Social Media Design</Link></li>
            </ul>

            <ul className="box input-box">
              <li className="link_name">Subscribe</li>
              <li><input type="text" placeholder="Enter your email" /></li>
              <li><input type="button" value="Subscribe" /></li>
            </ul>
          </div>
        </div>

        <div className="bottom-details">
          <div className="bottom_text">
            <span className="copyright_text">
              Copyright &#169; 2021 <Link to="/">Mediadunes</Link> All rights reserved
            </span>
            <span className="policy_terms">
              <Link to="/privacy">Privacy policy</Link>
              <Link to="/termsconditions">Terms & condition</Link>
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
